import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import Input from 'shared/form-input';
import Select from 'shared/form-input/select';
import { getCheckoutWithShipping } from '@/queries/getCart';
import getCheckoutId from '@/queries/getCheckoutId';
import states from '../../states.json';

import s from './billing-form.module.scss';

const requiredFields = ['lastName', 'address1', 'city', 'zip', 'province'];
const formFields = [...requiredFields, 'firstName', 'address2', 'country'];

export default function BillingForm({ sameAsShipping, form }) {
  const { data } = useQuery(getCheckoutId);
  const cartResponse = useQuery(getCheckoutWithShipping, {
    skip: !data?.checkout?.checkoutId,
    variables: {
      id: data?.checkout?.checkoutId
    }
  });

  const { state, events, emit } = form;
  const hydrateForm = () => {
    const { shippingAddress } = cartResponse?.data?.node || {};
    if (!shippingAddress || !sameAsShipping) return null;
    const inputValues = formFields.reduce(
      (acc, curr) => {
        return {
          inputs: {
            ...acc.inputs,
            [curr]: shippingAddress[curr === 'province' ? 'provinceCode' : curr]
          },
          touched: {
            ...acc.touched,
            [curr]: true
          }
        };
      },
      {
        inputs: {},
        touched: {}
      }
    );
    return emit.update(inputValues);
  };

  const handleSubmit = async e => {
    e.preventDefault();
  };
  useEffect(() => {
    hydrateForm();
  }, [cartResponse?.data?.node?.availableShippingRates.ready, sameAsShipping]);
  return (
    <div className={s.root}>
      <p className={s.title}>Billing Address</p>
      <form onSubmit={handleSubmit}>
        <div className={s.flex}>
          <Input
            placeholder="First Name"
            name="firstName"
            className={s.input}
            state={state}
            {...events}
          />
          <Input
            placeholder="Last Name"
            name="lastName"
            required
            className={s.input}
            state={state}
            {...events}
          />
        </div>
        <Input
          placeholder="Address"
          name="address1"
          className={s.input}
          required
          state={state}
          {...events}
        />
        <div className={s.flex}>
          <Input
            placeholder="Apartment, suite, etc. (optional)"
            name="address2"
            className={s.input}
            state={state}
            {...events}
          />
          <Input
            placeholder="City"
            required
            className={s.input}
            name="city"
            state={state}
            {...events}
          />
        </div>
        <div className={s.flex}>
          <Select
            value="US"
            name="country"
            placeholder="Country (US only)"
            className={s.input}
            state={state}
            {...events}
          >
            <option value="US">United States</option>
          </Select>
          <Select
            placeholder="Select a state"
            name="province"
            required
            className={s.input}
            state={state}
            {...events}
          >
            <option value="" hidden>
              Select a state
            </option>
            {states.map(({ name, value }) => (
              <option value={value} key={value}>
                {name}
              </option>
            ))}
          </Select>
          <Input
            name="zip"
            className={`${s.input} ${s.smaller}`}
            placeholder="ZIP code"
            required
            state={state}
            {...events}
          />
        </div>
      </form>
    </div>
  );
}
